import { FeatureToggles } from '@/features/feature-toggles'
import { type LoaderFunction, redirect, type RouteObject } from 'react-router'
import { links } from '@/utils/link'

/**
 * Creates routes for the email confirmation flow.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: '/confirm-email',
      loader: requireEmailConfirmationFlow,
      lazy: {
        Component: () =>
          import('@/features/email-confirmation/ConfirmEmailView/ConfirmEmailViewContainer').then(
            (r) => r.default,
          ),
      },
    },
    {
      path: '/email-confirmed',
      loader: requireEmailConfirmationFlow,
      lazy: {
        Component: () =>
          import('@/features/email-confirmation/EmailConfirmedView/EmailConfirmedViewContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}

const requireEmailConfirmationFlow: LoaderFunction = () => {
  if (!FeatureToggles.emailConfirmationFlow()) {
    return redirect(links.welcome())
  }

  return null
}
